import React from 'react'
import { Input } from '@at/design-system-elements'
import {
    StyledPanelButtonContainer,
    StyledSaveSearchFormContainer,
    StyledCharacterCounter,
    StyledPanelSaveSearchButton,
    StyledSaveSearchAlert,
} from './save-search-form.styles'
import { Alert } from '../../../__generated__/fed-graphql-types'
import { AddSaveErrorType } from './save-search-form'

interface SaveThisSearchProps {
    alert: Alert
    setAlert: (alert: Alert) => void
    searchName: string
    addSaveSearchError: AddSaveErrorType
    onNameChange: (value: string) => void
    onSaveClick: (name: string, searchUrl: string, alert: Alert) => void
}

export const SaveThisSearch = ({
    alert,
    setAlert,
    searchName,
    addSaveSearchError,
    onNameChange,
    onSaveClick,
}: SaveThisSearchProps) => {
    const canSubmit = (): boolean => !!searchName && !addSaveSearchError.isError
    return (
        <StyledSaveSearchFormContainer>
            <Input
                fieldType="text"
                id="save-search-name"
                name="save-search-name"
                label="Search name"
                value={searchName}
                error={addSaveSearchError.isError}
                errorText={addSaveSearchError.errorMessage}
                required={true}
                maxLength={30}
                onChange={(event: React.FormEvent<HTMLInputElement>) => {
                    onNameChange(event.currentTarget.value)
                }}
                data-testid="save-search-name"
                placeholder="Enter search name"
            />
            {!addSaveSearchError.isError && (
                <StyledCharacterCounter as="span">{`${searchName.length}/30 characters max`}</StyledCharacterCounter>
            )}
            <StyledSaveSearchAlert
                name="save-search-alert"
                id="save-search-alert"
                label="Send me alerts for this search"
                onChange={(event: React.FormEvent<HTMLInputElement>) =>
                    setAlert(event.currentTarget.checked ? Alert.ON : Alert.OFF)
                }
                data-testid={'save-search-alert'}
            />
            <StyledPanelButtonContainer>
                <StyledPanelSaveSearchButton
                    text="Save search"
                    attributes={{
                        'data-testid': 'save-search-save',
                    }}
                    onInteraction={async () => {
                        const searchUrl = window.location.pathname + window.location.search
                        onSaveClick(searchName, searchUrl, alert)
                    }}
                    disabled={!canSubmit()}
                />
            </StyledPanelButtonContainer>
        </StyledSaveSearchFormContainer>
    )
}
